var Counter_types_CounterSize = /*#__PURE__*/ function(CounterSize) {
    CounterSize["large"] = "large";
    CounterSize["medium"] = "medium";
    CounterSize["small"] = "small";
    CounterSize["extraSmall"] = "extraSmall";
    return CounterSize;
}({});
var Counter_types_CounterColor = /*#__PURE__*/ function(CounterColor) {
    CounterColor["green"] = "green";
    CounterColor["orange"] = "orange";
    CounterColor["red"] = "red";
    CounterColor["blue"] = "blue";
    CounterColor["purple"] = "purple";
    CounterColor["black"] = "black";
    CounterColor["white"] = "white";
    return CounterColor;
}({});
var Counter_types_CounterBackgroundColor = /*#__PURE__*/ function(CounterBackgroundColor) {
    CounterBackgroundColor["gray"] = "gray";
    CounterBackgroundColor["green"] = "green";
    CounterBackgroundColor["lightGreen"] = "lightGreen";
    CounterBackgroundColor["orange"] = "orange";
    CounterBackgroundColor["lightOrange"] = "lightOrange";
    CounterBackgroundColor["red"] = "red";
    CounterBackgroundColor["lightRed"] = "lightRed";
    CounterBackgroundColor["blue"] = "blue";
    CounterBackgroundColor["lightBlue"] = "lightBlue";
    CounterBackgroundColor["purple"] = "purple";
    CounterBackgroundColor["lightPurple"] = "lightPurple";
    CounterBackgroundColor["violet"] = "violet";
    CounterBackgroundColor["white"] = "white";
    return CounterBackgroundColor;
}({});
export { Counter_types_CounterBackgroundColor as CounterBackgroundColor, Counter_types_CounterColor as CounterColor, Counter_types_CounterSize as CounterSize };
